/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMessageQuestion = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 2v9h-2V4H4v16h.501L7.5 16H16v2H8.499L5.5 22H2V2zm-.98 20h-1.993v-2h1.992z" />
        <path d="M20.216 13c.618 0 1.134.086 1.547.26s.721.434.927.78c.207.338.31.764.31 1.275 0 .628-.19 1.177-.57 1.647-.36.438-.873.785-1.537 1.045l-.109.993h-1.757l-.359-1.902 1.139-.446c.354-.14.615-.293.78-.458a.867.867 0 0 0 .247-.619c0-.223-.082-.396-.247-.52s-.4-.186-.706-.186c-.24 0-.524.037-.854.112a7.616 7.616 0 0 0-1.027.322v-1.87c.347-.14.714-.247 1.102-.322.387-.074.76-.111 1.114-.111z" />
      </g>
    </g>
  </Icon>
);
export { SvgMessageQuestion as MessageQuestion };
